import { useSelector } from 'react-redux';

import { getUsageLimits } from 'js/src/data/usage-limit/usage-limit-selectors';

export function useEffectiveAnimationMinutes() {
    const usageLimit = useSelector(getUsageLimits);
    const hasSubscription = (usageLimit?.animation_seconds_limit_per_cycle ?? 0) > 0;
    const trialLimit = usageLimit?.trial_animation_seconds_limit ?? 0;
    const trialUsed = usageLimit?.trial_animation_seconds_used ?? 0;
    const isTrialOnly = !hasSubscription && trialLimit > 0;

    return {
        // Limit/used coalesce to 0/0 before this loads — callers deciding "out of minutes"
        // must gate on this rather than reading that as a confirmed zero balance.
        isLoaded: usageLimit?.isLoaded ?? false,
        hasSubscription,
        isTrialOnly,
        effectiveLimitSeconds: hasSubscription
            ? (usageLimit?.animation_seconds_limit_per_cycle ?? 0)
            : trialLimit,
        effectiveUsedSeconds: hasSubscription
            ? (usageLimit?.animation_seconds_used_in_cycle ?? 0)
            : trialUsed,
        trialRemainingSeconds: Math.max(0, trialLimit - trialUsed),
    };
}
